// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.isabel.io';

// Environment detection
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

// Log the current API configuration (only in development)
if (isDevelopment) {
  console.log('🔧 Development Mode');
  console.log(`🌐 API Base URL: ${API_BASE_URL}`);
  console.log(`📦 Environment: ${process.env.REACT_APP_ENV || 'development'}`);
} 